import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import EnabledFilter from 'components/form/filters/EnabledFilter';
import TextFilter from 'components/list/Filters/types/TextFilter';
import SelectField from 'components/input/SelectField/SelectField';
import DateRangeFilter from 'components/list/Filters/types/DateRangeFilter';

const TokenComponent = <TextFilter
    label='resources.discount_codes.fields.token'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='token'
/>;

const StatusFilter = <SelectField
    label='resources.discount_codes.fields.status'
    source='status'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: 'unused',
            name: 'resources.discount_codes.components.status.choices.unused',
        },
        {
            id: 'used',
            name: 'resources.discount_codes.components.status.choices.used',
        },
    ] }
/>;

const TypeFilter = <SelectField
    label='resources.discount_codes.fields.type'
    source='type'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: 'multi',
            name: 'resources.discount_codes.components.type.choices.multi',
        },
        {
            id: 'single',
            name: 'resources.discount_codes.components.type.choices.single',
        },
        {
            id: 'wallet',
            name: 'resources.discount_codes.components.type.choices.wallet',
        },
    ] }
/>;

const ExpiryDateFilter = <DateRangeFilter
    label='resources.discount_codes.fields.expiry_date'
    floatingLabelFixed={ true }
    fullWidth={ true }
    labelText='resources.discount_codes.components.expiry_date.placeholder'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
    source='expiry_date'
/>;

const DiscountCodesListFilters = (props) => {
    const filters = {
        basic: {
            token: {
                component: TokenComponent,
                matchTypes: {
                    default: filterMatchTypes.equals,
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            discount_id: {
                component: null,
            },
            status: {
                component: StatusFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            is_enabled: {
                component: EnabledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
        advanced: {
            expiry_date: {
                component: ExpiryDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            type: {
                component: TypeFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

DiscountCodesListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default DiscountCodesListFilters;



// WEBPACK FOOTER //
// ./src/pages/discountCodes/list/DiscountCodesListFilters.js